<template>
  <div class="historia">
    <banner-interno
      :banner="'bg_topo.jpg'"
      :imagem="history.image"
      :titulo="'História'"
      />
    <div class="container historia__info">
      <div class="row">
        <menu-sobre />
        <div class="col-12 col-md-9 historia__info__dados">
          <div class="row">
            <div class="col-12">
              <h2 class="ui-title-interna ui-title-interna--italic">{{history.preview}}</h2>
            </div>
            <div class="col-12 ui-description lh-36" v-html="history.description"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="historia__adendo ui-image--cover" :style="'background-image: url('+require('../assets/img/bg_history.jpg')+');'">
      <div class="container ui-container">
        <div class="row">
          <div class="col-12">
            <div class="ui-description ui-description--white ui-description--italic lh-36" v-html="operation.description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BannerInterno from './BannerInterno'
import MenuSobre from './MenuSobre'
import CtaConheca from './CtaConheca'
import { mapGetters } from 'vuex'
export default {
  components: {
    BannerInterno,
    MenuSobre,
    CtaConheca
  },
  data () {
    return {
      history: [],
      operation: []
    }
  },
  computed: {
    ...mapGetters([
      'page'
    ])
  },
  created () {
    this.$store.dispatch('showPage', 2)
      .then(() => {
        this.history = this.page
      })
    this.$store.dispatch('showPage', 3)
      .then(() => {
        this.operation = this.page
      })
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.historia {
  background: $bgIntern;
  &__adendo {
    .ui-description {
      column-count:2;
    }
  }
  &__info{
    margin-top: 21.5em;
    margin-bottom: 6.5em;
    @media (max-width: 1024px) {
      margin-top: 14em;
      margin-bottom: 4em;
    }
    @media (max-width: 800px) {
      margin-top: 11em;
      margin-bottom: 2em;
    }
    @media (max-width: 500px) {
      margin-top: 6em;
    }
    &__dados{
      p{
        margin-top: 12px;
      }
    }
  }
  @media (max-width: 767px) {
    &__adendo {
      .ui-description {
        column-count:1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Historia.vue